<template>
	<div class="text-left w-full">
		<vs-select autocomplete class="mt-5 w-full px-2" v-model="questionsByPage[index].properties[property]"  :label="$t(Label)">
		    <vs-select-item :key="index" :value="item.value" :text="$t(`MODULE.${item.text}`)" v-for="(item, index) in opcionesDefault" />
		</vs-select> 			
	</div>
</template>

<script type="text/javascript">
	import { mapState } from 'vuex';

	import OptionsDefault from './opcionesDefault.js';

	export default {	
		props: {
			index: Number, 
			label: String, 
			property: {
				type: String,
				required: false,
				default: 'default'
			},
			option: {
				type: String,
				required: false,
				default: null
			}
		},
		data() {
			return {
				...OptionsDefault,				
			}
		},				
		computed: {
			...mapState('resource',['questionsByPage']),
			inputType() {
				return this.questionsByPage[this.index].inputType;
			},
			type() {
				return this.questionsByPage[this.index].type;
			},
			Label() {
				if(this.label) return this.label;
				if(this.inputType === 'phone') return 'MODULE.selectTypePhone';
				return 'Opciones'
			},
			opcionesDefault() {				
				if(this.option !== null) return this[this.option];
				if(this.type === 'geo') return this.Geo;
				if(this.inputType === 'phone') return this.Phone;
				if(this.inputType === 'radio') return this.Radio;
				if(this.inputType === 'password') return this.Password;
				if(this.inputType === 'time') return this.Time;
				if(this.inputType === 'label' || this.inputType === 'section') return this.Fuentes;
				if(this.inputType === 'web' || this.inputType === 'document') return this.Viewer;
				if(this.inputType === 'paragraph') return this.Paragraph;
			}

		}
	}
</script>